import { LayaGL } from "../../../../layagl/LayaGL";
import { RenderCapable } from "../../../../RenderEngine/RenderEnum/RenderCapable";
import { Pool } from "../../../../utils/Pool";
import { Laya3DRender } from "../../../RenderObjs/Laya3DRender";
import { Command } from "./Command";
export class ComputeCommandBufferCMD extends Command {
    static create(value) {
        if (!LayaGL.renderEngine.getCapable(RenderCapable.ComputeShader)) {
            throw "device cant surpport computeBuffer function";
        }
        var cmd;
        cmd = ComputeCommandBufferCMD._pool.take();
        cmd.computeBuffer = value;
        return cmd;
    }
    constructor() {
        super();
        this._computeCMD = Laya3DRender.Render3DPassFactory.createComputeCommandAppatchCMD();
    }
    set computeBuffer(value) {
        this._computeCMD.computeContext = value.getResource();
        this._computeBuffer = value;
    }
    getRenderCMD() {
        return this._computeCMD;
    }
    recover() {
        ComputeCommandBufferCMD._pool.recover(this);
        super.recover();
        this._computeCMD.computeContext = null;
    }
}
ComputeCommandBufferCMD._pool = Pool.createPool(ComputeCommandBufferCMD);
